module.exports = __webpack_public_path__ + "img/franchising_help_support2.520fbae6.png";